import React, {useState, useEffect} from 'react'

const DownloadApp = () => {
  const [show, setShow] = useState('')
  const [android, setAndroid] = useState(false)

  useEffect(() => {
    getMobileOperatingSystem()
  }, [])

  function getMobileOperatingSystem() {
    var userAgent = navigator.userAgent || navigator.vendor || window.opera

    if (/android/i.test(userAgent)) {
      setAndroid(true)
      console.log('Android')
    }
    // iOS detection from: http://stackoverflow.com/a/9039885/177710
    if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
      setAndroid(false)
      console.log('iOS')
    }
  }

  return (
    <div className={`donwload-app-banner ${show}`}>
      <div onClick={() => setShow('none')}>
        <span>&times;</span>
      </div>
      <div className="info-banner-app">
        <h5>
          Descarga la App de AeroMall para{' '}
          {android ? <span>Android</span> : <span>iOS</span>}
        </h5>
        <span className="ads">Y disfruta de una mejor experiencia!</span>
      </div>
      <div>
        {android ? (
          <a
            href="https://play.google.com/store/apps/details?id=com.aeromall.client&hl=en"
            target="_blank"
          >
            Descargar
          </a>
        ) : (
          <a
            href="https://apps.apple.com/sv/app/aeromall/id1525460506?l=es"
            target="_blank"
          >
            Descargar
          </a>
        )}
      </div>
    </div>
  )
}

export default DownloadApp
